import { FormControl, FormGroup, Validators, FormArray } from "@angular/forms";

export interface event {
  id: string,
  user_id: string,
  name?: string,
  email?: string,
  vessel_id?: string,
  product_id?: string[],
  call_title: string,
  scheduled_time: string,
  scheduled_duration: number,
  status: number,
  incident_details?: string,
  report_id?: string[],
  troubleshooting_id?: string[],
  claim_id?: string[],
  sendEmail: number,
}

export interface scheduleData {
  code: number,
  data: event[],
  message: string,
}

export class eventForm {
  defaultForm = new FormGroup({
    user_id: new FormControl('', [Validators.required]),
    call_title: new FormControl('', [Validators.required]),
    scheduled_time: new FormControl('', [Validators.required]),
    scheduled_duration: new FormControl(30, [Validators.required, Validators.min(0)]),
    // removed for now
    // name: new FormControl(''),
    // email: new FormControl(''),
    vessel_id: new FormControl('', [Validators.required]),
    // product_id: new FormControl<string[]>([]),
    incident_details: new FormControl(null),
    product_id: new FormControl<string[]>([], [Validators.required]),
    sendEmail: new FormControl(0, [Validators.required]),
    // report_id: new FormControl<string[]>([]),
    // troubleshooting_id: new FormControl<string[]>([]),
    // claim_id: new FormControl<string[]>([]),
  })
}